import type { Access, LocationSummary } from '../auth/types';

/** Practice-management key sent as `X-Location-Id` on every scoped API call. */
export function ascendIdForLocationUuid(
  uuid: string,
  locations: LocationSummary[],
  access?: Access | null,
): string | null {
  if (access?.location === uuid && access.location_ascend_id) {
    return access.location_ascend_id;
  }

  return locations.find((location) => location.id === uuid)?.ascend_id ?? null;
}
